<div class="unlinked-successfully">
  <img src="{{ assetsURL + 'unlink-success.svg' }}" />
  <p class="heading2--bold content-main-color">{{ 'STORES.UNLINK_STORE.SUCCESS' | translate }}</p>
  <button (click)="closeDialog()" class="unlinked-successfully__button body2--medium">
    {{ 'STORES.OKAY' | translate }}
  </button>
</div>
